import React from 'react'
import Button from './Button';

const Card = (data: any) => {
    return (
        <section className={data.class || "card"} >
            <h1>{data.intro}</h1>
            <p>{data.data}</p>
            <Button text={data.text} page={data.page} route={data.route}/>

        </section>
    )
}

export default Card;
